module.exports = __webpack_public_path__ + "img/environment_119_1.83b2bbbb.jpg";